import * as React from "react";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import { Typography } from "@mui/material";

import fileTypes from "../../data/fileType";

function not(a: readonly string[], b: readonly string[]) {
  return a?.filter((value) => b?.indexOf(value) === -1);
}
function intersection(a: readonly string[], b: readonly string[]) {
  return a?.filter((value) => b?.indexOf(value) !== -1);
}

export default function TransferList({
  fileListLeft,
  fileListRight,
  dispatchAdd,
}: {
  fileListLeft: string[];
  fileListRight: string[];
  dispatchAdd: (element: any) => void;
}) {
  const [checked, setChecked] = React.useState<readonly string[]>([]);
  const [left, setLeft] = React.useState<readonly string[]>(fileListLeft);
  const [right, setRight] = React.useState<readonly string[]>(fileListRight);

  React.useEffect(() => {
    setLeft(not(fileListLeft, fileListRight));
    setRight(fileListRight);
  }, [fileListLeft, fileListRight]);

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const handleToggle = (value: string) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handleAllRight = () => {
    setRight(right.concat(left));
    dispatchAdd(right.concat(left));
    setLeft([]);
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    dispatchAdd(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    dispatchAdd(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };

  const handleAllLeft = () => {
    setLeft(left.concat(right));
    setRight([]);
    dispatchAdd([]);
  };

  const customList = (items: readonly string[], title: string) => (
    <Paper sx={{ width: 240, height: 330, overflow: "auto" }} elevation={0}>
      <Typography
        textAlign="center"
        sx={{
          pt: 2,
        }}
      >
        {title}
      </Typography>
      <List dense component="div" role="list">
        {items?.map((value: string) => {
          const labelId = `transfer-list-item-${value}-label`;
          const names_and_type = value?.split("---");

          return (
            <ListItemButton
              key={value}
              role="listitem"
              onClick={handleToggle(value)}
            >
              <Checkbox
                checked={checked.indexOf(value) !== -1}
                tabIndex={-1}
                disableRipple
                inputProps={{
                  "aria-labelledby": labelId,
                }}
              />
              {(names_and_type)&&<img
                src={fileTypes[names_and_type[2] ?? names_and_type[1]]}
                width="20"
              />}
              {names_and_type && <ListItemText
                id={labelId}
                primary={
                  names_and_type[0]?.length > 15
                    ? names_and_type[0].substring(0, 13) + "..."
                    : names_and_type[0]
                }
              />}
            </ListItemButton>
          );
        })}
      </List>
    </Paper>
  );

  return (
    <Grid container spacing={2} justifyContent="center" alignItems="center">
      <Grid item>{customList(left, "Uploaded files")}</Grid>
      <Grid item>
        <Grid container direction="column" alignItems="center">
          <Button
            sx={{ my: 0.5 }}
            variant="outlined"
            size="small"
            onClick={handleAllRight}
            disabled={left?.length === 0}
            aria-label="move all right"
          >
            ≫
          </Button>
          <Button
            sx={{ my: 0.5 }}
            variant="outlined"
            size="small"
            onClick={handleCheckedRight}
            disabled={leftChecked?.length === 0}
            aria-label="move selected right"
          >
            &gt;
          </Button>
          <Button
            sx={{ my: 0.5 }}
            variant="outlined"
            size="small"
            onClick={handleCheckedLeft}
            disabled={rightChecked.length === 0}
            aria-label="move selected left"
          >
            &lt;
          </Button>
          <Button
            sx={{ my: 0.5 }}
            variant="outlined"
            size="small"
            onClick={handleAllLeft}
            disabled={right.length === 0}
            aria-label="move all left"
          >
            ≪
          </Button>
        </Grid>
      </Grid>
      <Grid item>{customList(right, "Part of Collection")}</Grid>
    </Grid>
  );
}
